export const MAX_PRODUCT_NAME_LENGTH = 120;
export const MAX_PRODUCT_DESCRIPTION_LENGTH = 500;
export const MAX_PRODUCT_PRICE_RANGE_LENGTH = 80;
